import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import ProductsHero from '../components/products/ProductsHero';
import ProductsGrid from '../components/products/ProductsGrid';
import ProductDetail from '../components/products/ProductDetail';

export default function Products() {
  const location = useLocation();
  const [selectedProduct, setSelectedProduct] = useState(
    location.state?.openProduct || null
  );

  return (
    <>
      <Helmet>
        {/* ── Core ── */}
        <title>Shop Sneakers | SA Dropped — Verified Kicks Delivered Nationwide</title>
        <meta name="description" content="Shop verified authentic sneakers from Nike, Adidas, Jordan, New Balance, Converse and more. Every pair inspected before delivery. Shipped nationwide across South Africa from Durban." />
        <meta name="keywords" content="buy sneakers South Africa, Nike sneakers SA, Adidas sneakers SA, Jordan sneakers SA, New Balance SA, Converse SA, authentic sneakers online, sneaker shop Durban, SA Dropped shop, Air Force 1 buy SA, Dunk Low SA, Yeezy buy South Africa, sneakers delivered SA" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.sadropped.co.za/products" />

        {/* ── Open Graph ── */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="SA Dropped" />
        <meta property="og:title" content="Shop Sneakers | SA Dropped — Verified Kicks Delivered Nationwide" />
        <meta property="og:description" content="Browse SA Dropped's full collection of verified authentic sneakers. Nike, Adidas, Jordan and more — shipped to your door anywhere in South Africa." />
        <meta property="og:url" content="https://www.sadropped.co.za/products" />
        <meta property="og:image" content="https://www.sadropped.co.za/og-image.jpg" />
        <meta property="og:image:alt" content="SA Dropped — Shop Verified Sneakers" />
        <meta property="og:locale" content="en_ZA" />

        {/* ── Twitter ── */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@sa_dropped" />
        <meta name="twitter:title" content="Shop Sneakers | SA Dropped — Verified Kicks Delivered Nationwide" />
        <meta name="twitter:description" content="Browse SA Dropped's full collection of verified authentic sneakers. Shipped anywhere in South Africa." />
        <meta name="twitter:image" content="https://www.sadropped.co.za/og-image.jpg" />

        {/* ── Schema.org ── */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "Shop Sneakers — SA Dropped",
            "description": "Browse SA Dropped's full collection of verified authentic sneakers from Nike, Adidas, Jordan, New Balance and more.",
            "url": "https://www.sadropped.co.za/products",
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": "https://www.sadropped.co.za"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Shop",
                  "item": "https://www.sadropped.co.za/products"
                }
              ]
            },
            "publisher": {
              "@type": "Organization",
              "name": "SA Dropped",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.sadropped.co.za/logo_nav.png"
              }
            }
          }
        `}</script>
      </Helmet>

      <main>
        <ProductsHero />
        <ProductsGrid onSelectProduct={setSelectedProduct} />
        {selectedProduct && (
          <ProductDetail
            product={selectedProduct}
            onClose={() => setSelectedProduct(null)}
          />
        )}
      </main>
    </>
  );
}